import request from '@/utils/request.js'



/**
 * 获取护理记录
 * @param params
 * @returns {AxiosPromise}
 */
export function getNurseRecordTemplate(params) {
    return request({
        closeInterceptors:true,
        url: '/operateService/api/returnVisit/getNurseRecordTemplate',
        method: 'post',
        data: params
    })
}

/**
 * 保存护理记录
 * @param params
 * @returns {AxiosPromise}
 */
export function saveNursingEvaluation(params) {
    return request({
        closeInterceptors:true,
        url: '/tradeService/api/app/nurse/record/save/info',
        method: 'post',
        data: params
    })
}


/**
 * 获取护理记录
 * @param params
 * @returns {AxiosPromise}
 */
export function getNursingEvaluation(params) {
    return request({
        url: '/tradeService/api/app/nurse/record/get/info',
        method: 'post',
        data: params
    })
}

/**
 * 绑定用户虚拟手机号
 * @param params
 * @returns {AxiosPromise}
 */
export function bindUserPhone(params) {
    return request({
        url: '/operateService/api/uc/paas/bind/phone',
        method: 'post',
        data: params
    })
}

